import React, { useContext, useEffect, useState } from "react";
import {
    Flex,
    Stack,
    Box,
    Heading,
    Table,
    Thead,
    Tbody,
    useColorModeValue,
    Tr,
    Th,
    Td,
    Text
} from "@chakra-ui/react";
import UserContext from "../State/UserContext";

export default function FacturacionHistory() {
    const [tableData, setTableData] = useState();
    const [statusAlert, setStatusAlert] = useState();
    const { user } = useContext(UserContext);

    useEffect(() => {
        getTableData();
    }, [])

    async function getTableData() {
        var retries = 0;
        var response = await fetch("provider/getFacturacionHistory?meses=6", {
            method: "POST",
            headers: { "Content-Type": "application/json", "userToken": user.token }
        }).catch(function (error) {
            if (retries < 3) {
                retries = retries + 1;
                getTableData();
            } else {
                setStatusAlert("error");
                throw error;
            }
        });
        var data = await response.json();
        //console.log("data", data);
        setTableData(data);
    }

    function getTable() {
        if (!tableData) {
            return (
                <Text align="center">No hay datos</Text>
            );
        } else {
            return (
                <Table variant="simple" overflowY="auto" overflow="scroll">
                    <Thead>
                        <Tr>
                            <Th>Mail</Th>
                            <Th>Fecha</Th>
                            <Th>Archivo Descripcion</Th>
                            <Th>Archivo Factura</Th>
                            <Th>Estado de subida</Th>
                        </Tr>
                    </Thead>
                    <Tbody overflow="scroll" size="md">
                        {tableData?.map((element, pid) => {
                            return (
                                <Tr>
                                    <Td>{element.email}</Td>
                                    <Td>{element.date}</Td>
                                    <Td>{element.descriptionFile}</Td>
                                    <Td>{element.invoiceFile}</Td>
                                    <Td>{element.status == "0" ? "Fallido" : element.status == "1" ? "Exitoso" : "Desconocido"}</Td>
                                </Tr>
                            );
                        })}
                    </Tbody>
                </Table>
            );
        }
    }

    return (
        <Flex
            height="100vh"
            alignItems="center"
            justifyContent="center"
            backgroundColor="gray.100"
        >
            <Stack
                direction={{ base: "column" }}
                bg={{ md: "white" }}
                shadow="lg"
                w="160vh"
                h="90vh"
                rounded={'xl'}
            >
                <Stack align={'center'} spacing={2} p="50px">
                    <Heading
                        textTransform={'uppercase'}
                        fontSize={'3xl'}
                        color={useColorModeValue('gray.600', 'gray.200')}>
                        Historico de facturacion
                    </Heading>
                    <Text textAlign="center" fontSize={'lg'} color={'gray.600'}>
                        Lista de archivos de facturacion subidos para el prestador
                    </Text>
                </Stack>
                <Box overflow="auto">
                    { getTable() }
                    {statusAlert}
                </Box>
            </Stack>
        </Flex>
    );
}

